import React from 'react';
import { PRODUCT_ITEMS } from '../utils/constants';
export function WhatIsIncluded() {
  const colors = ['bg-amber-50 border-amber-200 text-amber-900', 'bg-red-50 border-red-200 text-red-900', 'bg-stone-100 border-stone-300 text-stone-900', 'bg-yellow-50 border-yellow-200 text-yellow-900', 'bg-rose-50 border-rose-200 text-rose-900'];
  return <section className="py-16 md:py-24 bg-gray-50 px-4" data-id="element-282">
      <div className="max-w-4xl mx-auto" data-id="element-283">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-stone-900 mb-12" data-id="element-284">
          Cosa troverai all'interno del Metodo Completo
        </h2>

        <div className="space-y-6" data-id="element-285">
          {PRODUCT_ITEMS.map((item, index) => <div key={index} className={`rounded-2xl border p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center space-y-4 md:space-y-0 md:space-x-6 shadow-sm ${colors[index]}`} data-id="element-286">
              <div className="w-12 h-12 rounded-full bg-white/60 flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-287">
                <span className="text-xl font-bold" data-id="element-288">{index + 1}</span>
              </div>
              <div data-id="element-289">
                <h3 className="text-xl md:text-2xl font-bold mb-2" data-id="element-290">
                  {item.title}
                </h3>
                <p className="opacity-90 text-lg leading-relaxed" data-id="element-291">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}